<template>
  <div v-if="content?.videoType === 'vimeo'">
    <vimeoEmbed :content="content" />
  </div>
  <div v-else-if="content?.videoId || content?.video?.en || content?.video?.jp">
    <youtubeEmbed :content="content" />
  </div>
</template>

<script setup>
const props = defineProps({
  content: Object
})
</script>
